document.addEventListener('DOMContentLoaded', initHeroBanner);
document.addEventListener('shopify:section:load', initHeroBanner);

function initHeroBanner() {
    const sliders = document.querySelectorAll('.block__hero-banner-slider');

    sliders.forEach((slider) => {
        // Prevent double initialization if Shopify fires section:load
        if (slider.swiper) return;

        new Swiper(slider, {
            slidesPerView: 1,
            loop: true,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            pagination: {
                el: '.block__hero-banner-slider-pagination',
                clickable: true,
                // Generates the custom dot HTML
                renderBullet: function (index, className) {
                    return '<span class="' + className + ' custom-dot"><svg class="circular-progress" height="8" width="8" viewBox="0 0 8 8" style="--stroke-dasharray: 20.420352248335"><circle cx="50%" cy="50%" fill="none" stroke-width="1.5" r="3.25" stroke="currentColor" stroke-opacity="0.2"></circle><circle cx="50%" cy="50%" fill="none" stroke-width="1.5" r="3.25" stroke="currentColor" stroke-linecap="round"></circle></svg></span>';
                }
            },
        });
    });
}
